import { render, staticRenderFns } from "./club-points-calendar.vue?vue&type=template&id=146ecc9c&"
import script from "./club-points-calendar.vue?vue&type=script&lang=js&"
export * from "./club-points-calendar.vue?vue&type=script&lang=js&"
import style0 from "./club-points-calendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('146ecc9c')) {
      api.createRecord('146ecc9c', component.options)
    } else {
      api.reload('146ecc9c', component.options)
    }
    module.hot.accept("./club-points-calendar.vue?vue&type=template&id=146ecc9c&", function () {
      api.rerender('146ecc9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/account/club-points-calendar.vue"
export default component.exports